module.exports = __webpack_public_path__ + "static/media/5_1.59709e9d.png";